import { useLocalSearchParams } from 'expo-router';

import { ContactProfilePage } from '@/components';

const parseContactId = (raw: string | string[] | undefined): number | null => {
  const value = Array.isArray(raw) ? raw[0] : raw;
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const ContactProfileRoute = () => {
  const { id } = useLocalSearchParams<{ id: string }>();
  const contactId = parseContactId(id);

  return contactId ? <ContactProfilePage id={contactId} /> : null;
};

export default ContactProfileRoute;
